"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var AbnormalState = function AbnormalState(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    state = props.state,
    title = props.title,
    desc = props.desc,
    operation = props.operation,
    stateUrl = props.stateUrl;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('abnormal-state');
  var classes = (0, _classnames.default)(prefixCls, className);
  var customizeImg = stateUrl ? {
    style: {
      backgroundImage: "url(".concat(stateUrl, ")")
    }
  } : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__section")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__obj")
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "".concat(prefixCls, "__obj--icon  ").concat(state)
  }, customizeImg))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__main")
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__title")
  }, title), desc && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__desc")
  }, desc), operation && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__oper")
  }, operation), children)));
};
var _default = AbnormalState;
exports.default = _default;